export default __webpack_public_path__ + "files/media/mmc@2x.33cde41c.png";